import {FC, PropsWithChildren, useCallback, useState} from "react";
import {PageAlert} from "./AlertContextValue";
import {AlertContext} from "./AlertContext";

export const AlertProvider: FC<PropsWithChildren> = ({children}) => {
  const [alert, setAlert] = useState<PageAlert>();
  const clearAlert = useCallback(() => setAlert(undefined), []);
  return (
    <AlertContext.Provider value={[alert, setAlert, clearAlert]}>
      {children}
    </AlertContext.Provider>
  );
};
